<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="dialogShow"
    class="items-no-padding phone-edit sidebar-dialog">
    <div class="sidebar-content">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">
        <div class="content px-6">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
          >
            <el-form-item
              :label="$t('User.newPass')"
              prop="newPsw_login"
            >
              <el-input
                v-model="form.newPsw_login"
                :placeholder="$t('_8_20_characters_including_uppercase_and_lowercase_letters_and_numbers')"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('User.confirmPass')"
              prop="reNewPsw_login"
            >
              <el-input
                v-model="form.reNewPsw_login"
                :placeholder="phFileter('User.plsInputConfirmPass')"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Choose_verification_method')"
              prop="codeType"
              class="select-type"
            >
              <el-radio v-model="form.codeType" :label="1">{{$t('Login.phoneVer')}}</el-radio>
              <el-radio v-model="form.codeType" :label="2">{{$t('Login.emailVer')}}</el-radio>
            </el-form-item>
            <el-form-item
              :label="$t('Register.verText')"
              prop="verCode"
            >
              <div class="send-line">
                <el-input v-model="form.verCode" :placeholder="phFileter('User.plsInputPhoVer')"></el-input>
                <span class="input-right" v-if="reSendMes">
                        {{isCodeNumber}}S
                    </span>
                <span class="input-right btn" @click="getVerCode" v-else>
                        {{$t('User.sendVeri')}}
                    </span>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        @click="submitHandle"
        color="primary"
      >{{$t('confirm')}}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { strongPwd } from '@/utils/validate';
import { updateCustPass,SettingVer } from '@/api/userCenter.js';
import { mapGetters } from 'vuex';

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: "emailEditDialog",
  components:{
    VuePerfectScrollbar
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    let _this = this;
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(_this.$t('User.plsInputPass')));
      } else {
        if (!strongPwd(value)) {
          callback(new Error(_this.$t('Register.passwordDes')));
        }else {
          callback();
        }
      }
    };
    var validateRePass = (rule, value, callback) => {
      if(value == ''){
        callback(new Error(_this.$t('User.plsInputConfirmPass')));
      }else {
        if (value != _this.form.newPsw_login) {
          callback(new Error(_this.$t('Register.notrepassword')));
        } else {
          callback();
        }
      }
    };
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      title: _this.$t('password'),

      form: {
        codeType: 1,
        verCode: '',
        newPsw_login: '',
        reNewPsw_login: ''
      },
      rules: {
        newPsw_login:[
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
          { validator: validatePass, trigger: 'blur'}
        ],
        reNewPsw_login:[
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
          { validator: validateRePass, trigger: 'blur'}
        ],
        codeType:[
          { required: true, message: _this.$t('please_choose'), trigger: 'change' },
        ],
        verCode:[
          { required: true, message: _this.$t('User.plsInputPhoVer'), trigger: 'blur' }
        ],
      },
      // 验证码
      reSendMes: false,
      isCodeNumber: 60,
    }
  },

  watch: {

  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created(){
  },
  methods: {
    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.close();
    },
    phFileter(data){
      return this.$t(data);
    },

    interfaceAjaxSuccess(){
      this.$emit('ajax-success');
    },
    cancelHandle(){
      this.close();
    },

    // 业务
    getVerCode() {
      let parmas = {
        custId: this.userInfo.id,
        sendType: 1,
        type: this.form.codeType
      };
      SettingVer(parmas).then((res) => {
        this.timerOut();
        this.reSendMes = true;
        this.$message({
          message: this.$t('User.verCodeSendSuccess'),
          type: 'success'
        });
      });
    },
    timerOut(){
      let _this = this;
      clearTimeout(this.timer1)
      this.timer1 = setTimeout(() => {
        clearTimeout(this.timer1)
        if(_this.isCodeNumber > 0){
          _this.isCodeNumber = --_this.isCodeNumber
          _this.timerOut();
        }else{
          clearTimeout(this.timer1)
          this.reSendMes = false;
          this.isCodeNumber = 60;
        }
      }, 1000);
    },
    colsecheckTransfer(){
      this.isCodeNumber = 60;
      clearTimeout(this.timer1);
      this.reSendMes = false;
      this.form.verCode = '';
    },
    submitHandle(){
      this.$refs.form.validate((valid) => {
        if(valid){
          let parmas = {
            verCode : this.form.verCode,
            // oldPwd: this.$md5(this.form.oldPsw_login.trim()),
            newPwd: this.$md5(this.form.reNewPsw_login.trim()),
            type: this.form.codeType
          }
          updateCustPass(parmas).then((res) => {
            this.form.reNewPsw_login = '';
            this.form.newPsw_login = '';
            this.form.oldPsw_login = '';
            this.colsecheckTransfer();
            this.$message({
              message: this.$t('User.passSetSuccess'),
              type: 'success'
            });
            this.$emit('ajax-success');
          })
        }else {
          console.log('error');
        }
      })
    }
  },
}
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.phone-edit {
  .content {
    .text-box {
      background-color: #F8F8F8;
      padding: 10px;
      border-radius: 6px;
      .text-box-line {
        margin-bottom: 10px;
        font-size: 14px;
        .text-left {
          color: #A29FAE;
        }
        .data-right {
          color: #6E6B7B;
        }
      }
    }
    .elform {
      margin-top: 30px;
    }
    .send-line {
      position: relative;
    }
    .input-right {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
      &.btn {
        cursor: pointer;
        color: $themeColor;
      }
    }
    .sendMes {
      position: absolute;
      bottom: 0;
      right: 20px;
      text-align: right;
      color: $themeColor;
      span {
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="scss">
.phone-edit {
  .vs-sidebar--items {

  }
  .scroll-area--customizer {
    height: calc(100% - 5rem);
  }
  .vs-sidebar {
    position: fixed;
    z-index: 999;
    .sidebar-content {
    }
  }
  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
